import type { FaireProductEntity } from "../../entity_types/product";

export const p_zbfwgazcex: FaireProductEntity = {
  token: "p_zbfwgazcex",
  type: "product",
  name: "Lulora 18K Gold Non-Tarnish Statement Ring",
  brandToken: "b_3tzh9mjdm6",
  brandName: "Flânerie by MAIQ",
  imageUrl: "https://cdn.faire.com/fastly/61799050e82918930906e6c644979cd578345da6394be1627a9915bcc6ea5a19.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7352470dc66c786cf6538dc659d3e5d4e385447d98c232aa7ed52149e3d4344a.jpeg",
    "https://cdn.faire.com/fastly/be9b5ad9751311a11e77bf60466be304225f1e23372d42698a1d482ef7da46dc.jpeg",
    "https://cdn.faire.com/fastly/36e340a72177c4db45d848d8933fd06117fd37ddb4d5e6a00a1014776da42002.jpeg",
    "https://cdn.faire.com/fastly/3b4bbe5e4795b9f974a4ea3ce8c3ad5cbd9d3d3b96574f40d05f3f0ade9a5f73.jpeg"
  ],
  priceDollars: 8.65,
  description: "18K Gold Non-Tarnish Statement Ring\n18K Gold Plating\nStainless Steel\nEnamel\nSize 7 Measurement: 0.682 Diameter/2.14 Circumference Adjustable \n\n- Lead-free, Nickel-safe\n- Hypoallergenic\n- Water Resistant\n",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:34.916Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
